// Auth context and provider
export { AuthProvider, useAuth, type AuthProviderWrapperProps } from './auth';

// Role redirect hook and utilities
export {
  useRoleRedirect,
  getRedirectForRole,
  hasRole,
  type ProfileType,
  type ExpectedRole,
  type RedirectResult,
  type RoleRedirectState,
} from './hooks/useRoleRedirect';
